
import React from 'react';
import { cn } from '@/lib/utils';
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useBreakpoint } from '@/hooks/use-mobile';
import { FeatureSectionData } from './types';

interface DesktopFeatureTabsProps {
  sections: FeatureSectionData[];
  activeTab: string;
}

const DesktopFeatureTabs: React.FC<DesktopFeatureTabsProps> = ({
  sections,
  activeTab
}) => {
  const { isTablet } = useBreakpoint();
  
  return (
    <TabsList className="bg-accent p-1 rounded-full shadow-md h-auto md:h-14">
      {sections.map((section) => (
        <TabsTrigger 
          key={section.id} 
          value={section.id}
          className={cn(
            "rounded-full transition-all duration-300 data-[state=active]:shadow-md text-sm md:text-base font-medium",
            "data-[state=active]:bg-white data-[state=active]:text-[#003a70]",
            "data-[state=inactive]:text-gray-600 hover:text-[#003a70]",
            isTablet ? "h-10 px-4" : "h-12 px-6",
            activeTab === section.id ? "scale-[1.02]" : ""
          )}
        >
          <div className="flex items-center gap-1.5 md:gap-2">
            <div className={cn(
              "rounded-full p-1 md:p-1.5",
              activeTab === section.id ? "bg-[#003a70]" : "bg-gray-200"
            )}>
              {React.isValidElement(section.icon) ? 
                React.cloneElement(section.icon as React.ReactElement, {
                  size: isTablet ? 14 : 16,
                  className: activeTab === section.id ? "text-white" : "text-gray-500"
                }) : 
                section.icon
              }
            </div>
            <span>{section.title}</span>
          </div>
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default DesktopFeatureTabs;
